import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ReportForm from '../components/reports/ReportForm';
import LanguageSwitcher from '../components/common/LanguageSwitcher';
import ThemeSwitcher from '../components/common/ThemeSwitcher';
import DisclaimerFooter from '../components/common/DisclaimerFooter';

const AnonymousReport = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  // Set document direction on mount and language change
  useEffect(() => {
    const lng = localStorage.getItem('language') || 'ar';
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-shayek-light-50 to-shayek-light-100 dark:from-shayek-dark dark:to-shayek-dark-50 transition-colors">
      {/* Header */}
      <header className="bg-white dark:bg-shayek-dark shadow-sm border-b border-shayek-light-300 dark:border-shayek-dark-200 transition-colors">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/')}
                className="text-2xl font-bold text-shayek-primary dark:text-shayek-red-light hover:text-shayek-primary-600 dark:hover:text-shayek-red-light transition-colors"
              >
                {t('common.appName')}
              </button>
            </div>
            <div className="flex items-center gap-4">
              <ThemeSwitcher />
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white dark:bg-shayek-dark-100 rounded-2xl shadow-shayek-lg p-8 border border-shayek-light-300 dark:border-shayek-dark-200 transition-colors">
          {/* Title */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-shayek-light-900 dark:text-shayek-dark-900 mb-2">{t('report.anonymousTitle')}</h1>
            <p className="text-shayek-light-600 dark:text-shayek-dark-600">{t('report.anonymousSubtitle')}</p>
          </div>

          <ReportForm onCancel={() => navigate(-1)} />
        </div>
      </main>
      <DisclaimerFooter />
    </div>
  );
};


export default AnonymousReport;

